import { get } from 'lodash';
import { mapGetters } from 'vuex';
import cmsPlaceholderMixin from 'framework/mixins/cms/cms-placeholder';


export default {
    mixins: [
        cmsPlaceholderMixin,
    ],
    props: {
        partialName: String,
    },
    computed: {
        ...mapGetters(['router']),
        isPartialLoaded() {
            return !!this.router.partials[this.partialName];
        },
        isPartialAllowed() {
            return get(this.$route, 'meta.api.query.partials', []).includes(this.partialName);
        },
        showPartial() {
            return this.isPartialLoaded && this.isPartialAllowed;
        },
        partial() {
            return get(this.router.partials, `${ this.partialName }`, {});
        },
    },
};



// WEBPACK FOOTER //
// ./vehi-industriepfad/assets/src/js/app/framework/mixins/cms/cms-partial/index.js